import { type Ref, computed } from 'vue'
import type { CollectQuestionResponse } from '@/api/generated'

/**
 * Questions sorted by `order`, minus the backend's `hidden_question_ids`.
 * A hidden question whose show_if reads a pending answer stays in until the PATCH lands,
 * so the thread holds on it instead of skipping a branch that may open.
 */
export function useVisibleQuestions(
  questions: Ref<CollectQuestionResponse[] | null | undefined>,
  hiddenQuestionIds: Ref<string[]>,
  pendingAnswerIds: Ref<Set<string>>
) {
  const visibleQuestions = computed(() => {
    const hidden = new Set(hiddenQuestionIds.value)
    const list = questions.value ?? []
    const sorted = [...list].sort((a, b) => a.order - b.order)

    return sorted.filter(
      (question) =>
        !hidden.has(question.id) || question.show_if_question_ids.some((id) => pendingAnswerIds.value.has(id))
    )
  })

  return { visibleQuestions }
}
